<template>
<span class="grey--text page-title text-xs-left">
  <slot></slot>
</span>
</template>

<script>
import {
  checkAccess
} from "@/scripts/groupFuncs";
export default {
  name: "PageTitle"
};
</script>

<style lang="scss" scoped>
.page-title {
    user-select: none;
    padding: 8px 0;
    width: 100%;
    margin: 0;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/PageTitle.vue